import {
  Row, Col, Grid, Layout,
} from 'taxaroo-ui';
import { Link } from 'react-router-dom';
import Logo from '~src/assets/images/taxaroo_logo.svg';
import FeaturesSection from './FeaturesSection';
import * as styles from './styles.module.css';
import RegisterSection from './RegisterSection';

const { useBreakpoint } = Grid;
const { Header } = Layout;

interface RegisterPageProps {
  free?: boolean;
}
const RegisterTemplate = ({ free = false }: RegisterPageProps) => {
  const screens = useBreakpoint();
  return (
    <Layout>
      <Header
        className={[styles.header, 'elevated']}
      >
        <Link to="/"><Logo className={styles.logo} /></Link>
        <Link to="/login" className={styles.signInLink}>Sign In</Link>
      </Header>
      <Row justify="center" className={styles.signupContainer}>
        <Row gutter={100} className={styles.reverseOnSmall}>
          <Col span={24} xl={12} className={styles.textContainer}>
            <FeaturesSection free={free} />
          </Col>
          <Col span={24} xl={12} className={styles.registerSectionCol}>
            <RegisterSection free={free} />
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: 60 }}>
          <p style={{ textAlign: 'center' }}>
            <a style={{ color: 'inherit' }} href="https://taxaroo.com/privacy" target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
            {' '}
            |
            {' '}
            <a style={{ color: 'inherit' }} href="https://taxaroo.com//terms-of-use" target="_blank" rel="noreferrer">
              Terms of Service
            </a>
          </p>
        </Row>
      </Row>
    </Layout>
  );
};

RegisterTemplate.defaultProps = {
  free: false,
};

export default RegisterTemplate;
